import React, { useEffect } from 'react';
import { SubtitleThree } from '@/styles/theme/default/typography';
import styled from 'styled-components';
import useSale from '@/hooks/useSale';
import {useSelector} from "react-redux";
import { gql, useQuery } from '@apollo/client';

function BannerText({ onClick, onColors }) {
  const { saleStage } = useSale();

  const user = useSelector(state => state.Auth.user);
  const isTrade = [2].includes(parseInt(user.role_id));

  const BANNER_TEXT = gql`
    query bannerText($stage: String, $audience: String!) {
      bannerText(stage: $stage, audience: $audience) {
        id
        text
        bg_color
        text_color
      }
    }
  `;
  const audience = isTrade ? 'trade' : 'guest';
  const { data } = useQuery(BANNER_TEXT, {
    variables: { stage: saleStage || null, audience }
  });
  const configuredText = data?.bannerText?.text || '';
  const bgColor = data?.bannerText?.bg_color || null;
  const textColor = data?.bannerText?.text_color || null;

  useEffect(() => {
    if (onColors) {
      onColors({ bgColor, textColor });
    }
  }, [bgColor, textColor]);

  return (
    <SubtitleThree className="copy">
      {configuredText && <span>{configuredText}</span>}
      <SeeDetailsBtn onClick={onClick} className="see-details-btn">
        See Details
      </SeeDetailsBtn>
    </SubtitleThree>
  );
}

const SeeDetailsBtn = styled.button`
  background: transparent;
  border: none;
  color: ${props => props.theme.colors.charcoal};
  font-weight: normal;
  letter-spacing: 0.12em;
  margin: 0 0 0 5px;
  padding: 0;
  text-decoration: underline;
`;

export default BannerText;
